import React from "react";
import { AudioLines, Keyboard } from "lucide-react";

const PILL_ICON = {
  voice: AudioLines,
  text: Keyboard,
};

/**
 * Section 01 — short description plus pill chips (Voice / Text by default).
 * The chip icon is keyed off the lowercased label.
 */
const WhatThisIs = ({ section, number = "01" }) => {
  if (!section) return null;
  const {
    title = "What this is",
    description,
    pill_chips = [],
  } = section;

  return (
    <div className="corp-section-card">
      <div className="flex items-center gap-3">
        <span className="corp-section-num">{number}</span>
        <h2 className="corp-section-title">{title}</h2>
      </div>
      {description && <p className="corp-section-desc">{description}</p>}
      {pill_chips.length > 0 && (
        <div className="flex flex-wrap items-center gap-3">
          {pill_chips.map((chip, idx) => {
            const Icon = PILL_ICON[String(chip).toLowerCase()] || null;
            return (
              <span key={idx} className="corp-pill">
                {Icon && <Icon size={16} />}
                {chip}
              </span>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WhatThisIs;
